import { apolloRichTextSchema } from '@ecomm/contentful-schemas'
import { contentfulImageSchema } from '@ecomm/contentful/components'

import { quoteWizardSchema } from '@ecomm/shared-components'
import { type TypeOf, z } from '@simplisafe/ewok'

export const duplexSmallTextSchema = z.object({
  __typename: z.literal('Text'),
  text: apolloRichTextSchema
})

export const duplexImageLinkSchema = z.object({
  __typename: z.literal('ImageLink'),
  image: contentfulImageSchema
})

export const possibleEmbeddedSchema = z.union([
  duplexSmallTextSchema,
  duplexImageLinkSchema,
  quoteWizardSchema.shape.quoteWizard
])

export const duplexSectionSchema = z.object({
  __typename: z.literal('Duplex'),
  leftCollection: z.object({
    items: possibleEmbeddedSchema.array()
  }),
  rightCollection: z.object({
    items: possibleEmbeddedSchema.array()
  })
})

export const gatsbyDuplexSectionSchema = z.object({
  __typename: z.literal('ContentfulDuplex'),
  contentful_id: z.string()
})

export type PossibleEmbeddedComponent = TypeOf<typeof possibleEmbeddedSchema>
export type DuplexSmallText = TypeOf<typeof duplexSmallTextSchema>
export type DuplexImageLink = TypeOf<typeof duplexImageLinkSchema>
export type DuplexSectionSchema = TypeOf<typeof duplexSectionSchema>
export type GatsbyDuplexSectionSchema = TypeOf<typeof gatsbyDuplexSectionSchema>
